import React, { useState } from 'react';
import './InviteCard.css';
import { getAuth } from 'firebase/auth';
import Cookies from 'js-cookie';

const InviteCard = ({ invite }) => {
  const { inviteId, communityName, fromNames, personalMessage } = invite;
  const [status, setStatus] = useState('pending'); // 'pending' | 'accepted' | 'declined' | 'loading'

  const respond = async (action) => {
    setStatus('loading');
    try {
      const auth = getAuth();
      const token = await auth.currentUser.getIdToken(true);
      const csrfToken = Cookies.get('mytoken');
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/group-match/${action}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          ...(csrfToken && { 'X-CSRF-Token': csrfToken })
        },
        body: JSON.stringify({ inviteId })
      });
      if (!res.ok) throw new Error('Request failed');
      setStatus(action === 'accept' ? 'accepted' : 'declined');
    } catch (err) {
      console.error('[InviteCard] respond error:', err);
      setStatus('pending');
    }
  };

  if (status === 'accepted') {
    return (
      <div className="invite-card invite-card--accepted">
        <span className="invite-card__icon">🎉</span>
        <p className="invite-card__title">You've joined the group!</p>
        <p className="invite-card__sub">Check your conversations to chat with the group.</p>
      </div>
    );
  }

  if (status === 'declined') {
    return (
      <div className="invite-card invite-card--declined">
        <p className="invite-card__title">Invitation declined</p>
      </div>
    );
  }

  return (
    <div className="invite-card">
      <div className="invite-card__header">
        <span className="invite-card__icon">👥</span>
        <div>
          <p className="invite-card__title">Group invite from {communityName}</p>
          <p className="invite-card__from">{fromNames} would like you to join their group</p>
        </div>
      </div>
      {personalMessage && (
        <blockquote className="invite-card__message">"{personalMessage}"</blockquote>
      )}
      <div className="invite-card__actions">
        <button
          className="invite-card__btn invite-card__btn--accept"
          onClick={() => respond('accept')}
          disabled={status === 'loading'}
        >
          Join group
        </button>
        <button
          className="invite-card__btn invite-card__btn--decline"
          onClick={() => respond('decline')}
          disabled={status === 'loading'}
        >
          Decline
        </button>
      </div>
    </div>
  );
};

export default InviteCard;
